export const features = [
   {
      name: 'High Quality',
      description: 'crafted from top materials',
      img: '../../assets/feature/trophy1.svg'
   },
   {
      name: 'Warrany Protection',
      description: 'Over 2 years',
      img: '../../assets/feature/guarantee.svg'
   },
   {
      name: 'Free Shipping',
      description: 'Order over $150',
      img: '../../assets/feature/shipping.svg'
   },
   {
      name: '24 / 7 Support',
      description: 'Dedicated support',
      img: '../../assets/feature/customer-support.svg'
   }
];

